import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/design-system';
import '@/styles/globals.css';
import '@/locales/i18n';

import { App } from '@/app/App';
import { installTranslationDomGuard, logger } from '@/lib';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

logger.info('Starting application');
// Must run before React renders, or the first translated update can still crash
installTranslationDomGuard();
import("preline").then(() => {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
